import React, { useEffect } from 'react';
import { useParams, NavLink } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import { env, meta } from '~/commons/config';
import Padding from '../../app/components/layout/Padding.jsx';
import Article from '../../app/components/blocks/Article.jsx';

const PageArticle = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({ url: `api/quiz/articles/${_id}` });
  }, []);

  return (
    <PageHttp res={res}>
      {(doc) => {
        meta.set({ title: doc.title });

        return (
          <>

            <Padding className="pos-sticky bg-light py-3 d-none d-md-block text-secondary">
            <NavLink to="." className="small text-primary mr-4">
                    <img
                      src={'assets/img/long-arrow-left.svg'}
                      style={{ width: '38px', height: '9px' }}
                    />
                    &nbsp;
                    返回上一頁
                  </NavLink>
              {env.subjects[doc.subjects[0]]?.zhhk}閱讀文章
            </Padding>
            <div className="py-3 container">
              <Article article={doc} />
            </div>
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageArticle;
